import { Link } from "react-router-dom";
import { useLiveStats } from "../../hooks/useLiveStats";
import { useSiteCopy } from "../../context/SiteCopyContext";
import { CopyText } from "../CopyText";
import { getAtPath } from "../../lib/siteCopyPaths";
import { statsWatchLabel } from "../../lib/statsDisplay";

export function HomeLiveCta() {
  const stats = useLiveStats();
  const { copy } = useSiteCopy();
  const viewers = stats?.watchingNow ?? 0;
  const registered = stats?.registered ?? 0;
  return (
    <section className="section home-live-cta">
      <div className="home-live-card">
        <div className="home-live-meta">
          <div className="home-live-pill">
            <span className="live-dot"></span>{" "}
            <CopyText path="home.liveCta.pill" as="span" />
          </div>
          <div className="home-live-stats">
            <div>
              <b>{viewers.toLocaleString()}</b>
              <span>
                {statsWatchLabel(
                  stats,
                  String(getAtPath(copy, "home.liveCta.statWatchLabel") ?? "watching now"),
                )}
              </span>
            </div>
            <div className="home-live-divider" aria-hidden="true"></div>
            <div>
              <b>{registered.toLocaleString()}</b>
              <span>{String(getAtPath(copy, "home.liveCta.statRegLabel") ?? "")}</span>
            </div>
          </div>
        </div>
        <div className="home-live-body">
          <h2 className="sec-title sec-title-sm">
            <CopyText path="home.liveCta.title" as="span" />
          </h2>
          <p style={{ opacity: 0.78, marginBottom: 28 }}>
            <CopyText path="home.liveCta.body" as="span" />
          </p>
          <Link to="/live" className="btn btn-primary">
            {String(getAtPath(copy, "home.liveCta.cta") ?? "")} <span className="arr">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
